import { render, staticRenderFns } from "./pontos-de-interesse.vue?vue&type=template&id=11dc862d&scoped=true&"
import script from "./pontos-de-interesse.vue?vue&type=script&lang=js&"
export * from "./pontos-de-interesse.vue?vue&type=script&lang=js&"
import style0 from "./pontos-de-interesse.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pontos-de-interesse.vue?vue&type=style&index=1&id=11dc862d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dc862d",
  null
  
)

export default component.exports